import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './Abundance.module.scss'

interface AbundanceProps {
  children?: React.ReactNode
  className?: string
  count?: number
}

export const Abundance: FC<AbundanceProps> = ({ children, className, count }) => {
  if (!count) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {children}
      </>
    )
  }

  return (
    <div className={styles.abundance}>
      {children}
      <span className={clsx(styles.counter, className)}>{count}</span>
    </div>
  )
}
